<template>
  <div class="qrcode">
    <div class="qrcode_content" :id="name"></div>
  </div>
</template>
<script>
import QRcode from "qrcodejs2";
let qrcode = "";
export default {
  name: "qrcode",
  data() {
    return {};
  },
  computed: {
    name: {
      get() {
        let sid = "qrcode";
        if (this.sid) {
          sid = this.sid;
        }
        return sid;
      },
      set(value) {
        this.name = value;
      },
    },
    value: {
      get() {
        let value = "https://blog.csdn.net/LiaoFengJi";
        if (this.text) {
          value = this.text;
        }
        return value;
      },
      set(value) {
        this.value = value;
      },
    },
    qrwidth() {
      let width = 0;
      if (this.swidth) {
        width = this.swidth; //370*320/(window.innerWidth)/20
      } else {
        width = 5.33; //250*320/(window.innerWidth)/20
      }
      return width;
    },
  },
  props: {
    sid: {
      type: String,
    },
    text: {
      type: String,
    },
    swidth: {
      type: Number,
    },
  },
  methods: {
    qrcode() {
      if (qrcode) {
        // qrcode.clear();
        // qrcode.makeCode('new content');
        qrcode = null;
      } else {
        qrcode = new QRcode(this.name, {
          width: 60,
          height: 60, // 高度  ,250*320/(window.innerWidth)/20
          text: this.value, // 二维码内容
          image: "",
          correctLevel: QRcode.CorrectLevel.L,
        });
      }
    },
  },
  destroyed() {
    // qrcode.clear();
    qrcode = null;
  },
  mounted() {
    this.qrcode();
  },
};
</script>
<style scoped>
@import "../assets/styles/style.css";
</style>